// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".debug-row[data-v-1713478a]{border-bottom:1px solid #c8c8d4;min-height:50px;display:flex;align-items:center}@media(max-width:767px){.debug-row[data-v-1713478a]{font-size:14px}}.debug-row__title[data-v-1713478a]{min-width:170px;font-weight:700}@media(max-width:767px){.debug-row__title[data-v-1713478a]{font-weight:600}}", ""]);
// Exports
module.exports = exports;
